import {
  Factory, Sun, HardHat, Landmark, Network, Gauge, ScanSearch, FileSearch,
  Handshake, Workflow, ShieldCheck, MapPinned, FileSignature, Circle,
} from "lucide-react";

const MAP = { Factory, Sun, HardHat, Landmark, Network, Gauge, ScanSearch, FileSearch, Handshake, Workflow, ShieldCheck, MapPinned, FileSignature };

export const LineIcon = ({ name, className = "h-6 w-6" }) => {
  const I = MAP[name] || Circle;
  return <I className={className} strokeWidth={1.4} aria-hidden="true" />;
};
